import config from '@/temp/config';
import type { AppContext } from '@/types';
import { isLocalhost } from '@shared-jss/utils/env';
import { get } from 'design.zorgdomein';

export const getBaseUrl = (appContext: AppContext) =>
    isLocalhost() ? appContext.sitecoreApiHost : '';

export const getClientControllerUrl = (appContext: AppContext, endpoint: string) => {
    const baseUrl = getBaseUrl(appContext);
    const virtualFolder = appContext.sitecoreVirtualFolder;

    return `${baseUrl}${virtualFolder}clientcontroller/productpagesclient${endpoint}`;
};

export const createHeaders = (options?: HeadersInit) => {
    const headers = new Headers();
    const verificationToken = document.querySelector<HTMLInputElement>(
        "input[name='__RequestVerificationToken']"
    );

    if (!isLocalhost() && verificationToken) {
        headers.set('__RequestVerificationToken', verificationToken.value);
    }

    if (options) {
        const headerOptions = new Headers(options);

        headerOptions.forEach((value, key) => {
            headers.set(key, value);
        });
    }

    return headers;
};

export const getRequest = <TResponse>({
    appContext,
    endpoint,
    language,
    params
}: {
    appContext: AppContext;
    endpoint: string;
    language: string;
    params?: Record<string, string>;
}) => {
    const url = getClientControllerUrl(appContext, endpoint);
    const urlParams = new URLSearchParams();
    const headers = createHeaders();

    urlParams.append('proposition', appContext.proposition);
    urlParams.append('sc_lang', language);
    urlParams.append('sc_apikey', config.sitecoreApiKey);

    if (params) {
        for (const key in params) {
            urlParams.append(key, params[key]);
        }
    }

    return get<TResponse>(`${url}?${urlParams.toString()}`, {
        headers,
        credentials: 'include'
    });
};
